import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import router from './router'
import store from './store'
import {
	getSession,
	setSession,
	setlocalStorage,
	getlocalStorage
} from '@/utils/auth.js'
import '@/permission'

import App from './App'
import VueClipBoard from 'vue-clipboard2'
// 监听页面路由变化 
// router.afterEach((to) => {  
// 	// 这里是处理翻译下拉框在登录页位置异常
//     const myElement = document.getElementById('translate');  
//     const hiddenPaths = ['/login'];  
//     // 如果当前路径在指定路径中，则隐藏元素  
//     if (hiddenPaths.includes(to.path)) {  
// 		myElement.style.top = '18px';
//         // myElement.style.display = 'none';  
//     } else {  
// 		myElement.style.top = '2px';
//         // myElement.style.display = 'block';  
//     }  
// });  
Vue.use(VueClipBoard)
// set ElementUI lang to EN
// Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI)

import './icons'

//判断方法-个人1中心
function hasBtnPermission(permission) {
	//取出上面所存储的登录人按钮权限
	let getBtnPermissionArr = JSON.parse(getSession('auth_tab'));
	//因为indexOf如果不包含的话就会返回-1 所以 -1不会大于-1 按钮就不会显示
	//如果indexOf包含的话就会返回对应的第一次出现的位置，至少为0
	//因此0 >-1 就会显示
	if (getBtnPermissionArr) {
		return getBtnPermissionArr.indexOf(permission) > -1;
	}
}
//判断方法
function shopHasBtnPermission(permission) {
	//取出上面所存储的登录人按钮权限
	let getBtnPermissionArr = JSON.parse(getSession('button_menu_list'));
	//因为indexOf如果不包含的话就会返回-1 所以 -1不会大于-1 按钮就不会显示
	//如果indexOf包含的话就会返回对应的第一次出现的位置，至少为0
	//因此0 >-1 就会显示
	if (getBtnPermissionArr) {
		return getBtnPermissionArr.indexOf(permission) > -1;
	}
}
Vue.prototype.hasPermShop = shopHasBtnPermission
Vue.prototype.hasPerm = hasBtnPermission
Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
})
